import { TwoCol } from "./fundCardHelpers";
import { InfoRow } from "../UI";

export default function RetirementTab({ fund, cs }) {
  return (
    <>
      {fund.retirementProjections?.length ? fund.retirementProjections.map((proj, i) => (
        <div key={i} style={{ marginBottom: 14, padding: 12, background: "#f8fafc", borderRadius: 10, border: "1px solid #e2e8f0" }}>
          <div style={{ fontWeight: 700, fontSize: 13, color: cs.accent, marginBottom: 8 }}>
            {proj.age === 0 ? "בגיל הנוכחי" : `גיל פרישה ${proj.age}`}
            {proj.shem_maslol && <span style={{ fontWeight: 400, fontSize: 11, color: "#64748b", marginRight: 8 }}>({proj.shem_maslol})</span>}
          </div>
          <TwoCol>
            <div>
              <InfoRow label="חיסכון צפוי (כולל פרמיות)" value={proj.totalSavings} money bold color={cs.accent} />
              <InfoRow label="חיסכון צפוי (ללא פרמיות)" value={proj.totalSavingsNoPrem} money />
              <InfoRow label="מקדם מובטח לפרישה" value={proj.mekadem} />
              <InfoRow label="שיעור פנסיית זקנה" value={proj.sheurPensiaZikna} pct />
            </div>
            <div>
              {proj.kupot?.map((k, j) => (
                <div key={j}>
                  <InfoRow label={`קצבה (${k.sugKupa || ""})`} value={k.pensionMonthly || k.pension} money bold color="#2563eb" />
                  <InfoRow label="תשואה בתחזית" value={k.tsua} pct />
                </div>
              ))}
            </div>
          </TwoCol>
        </div>
      )) : <div style={{ color: "#94a3b8", fontSize: 13 }}>אין תחזיות פרישה לחשבון זה</div>}
    </>
  );
}
